/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import { gql } from '@apollo/client';

/*
{
    "data": {
        "samplePage": {
            "data": {
                "id": "1",
                "attributes": {
                    "elementone": "text one 111",
                    "elementtwo": "text two ",
                    "elementthree": "text three",
                    "createdAt": "2023-04-04T18:31:09.205Z",
                    "updatedAt": "2023-04-04T18:47:00.239Z",
                    "publishedAt": "2023-04-04T18:31:10.232Z"
                }
            }
        }
    }
}
*/

export const GET_SAMPLE_PAGE = gql`
  query {
    samplePage {
      data {
        id
        attributes {
          elementone
          elementtwo
          elementthree
          createdAt
          updatedAt
          publishedAt
        }
      }
    }
  }
`;
export const TNC = gql`
  query ($locale: I18NLocaleCode) {
    tnc(locale: $locale) {
      data {
        id
        attributes {
          headersection {
            headertitle
            headerdescription
          }
          pagecontent
          publishedAt
          createdAt
          updatedAt
        }
      }
    }
  }
`;
export const HOME_PAGE = gql`
  query homePageData($locale: I18NLocaleCode) {
    homePage(locale: $locale) {
      data {
        id
        attributes {
          misclinks {
            misclable
            links {
              linklable
              url
            }
          }
          links {
            linklable
            url
          }
          contactuslink {
            linklable
            url
          }
          contactus
          followtd
          equalhousing
          memberfdic
          securitynote
          copyright
          social {
            url
          }
          exploreandlearn_card{
            id
            cardlabel
            carddescription
            card_link{
              linklabel
              linkurl
            }
            cardimage{
              data{
                id
                attributes{
                  name
                  url
                }
              }
            }
          }
          gettingstarted_cards{
            id
            cardlabel
            carddescription
            card_link{
              linklabel
              linkurl
            }
            cardimage{
              data{
                id
                attributes{
                  name
                  url
                }
              }
            }
          }
          learnaboutbuyingandselling{
            linklabel
            linkurl
          }


        }
      }
    }
  }
`;
export const SESSION_TIMEOUT = gql`
  query sessiontimeoutData($locale: I18NLocaleCode) {
    sessiontimeout(locale: $locale) {
    data {
      id
      attributes {
       sessiontimeout_header{
         headertitle
         headerdescription
       }
        sessiontimeout_btn_home{
          linklable
          url
        }
        sessiontimeout_signin_btn_label        }}}}`;
export const UNSUBSCRIBE =gql`
query ($locale: I18NLocaleCode){
  unsubscribe (locale: $locale){
    data {
      id
      attributes {
        unsubscribe_header{
          headertitle
          headerdescription
        }
        unsubscribe_preinstructions
        unsubscribe_postinstructions
        unsubscribe_email_placeholder
        unsubscribe_reemail_placeholder
        unsubscribe_btn_cancel_label
        unsubscribe_btn_submit_label
      }
    }
  }
}
`;

export const Faq_Page = gql`
  query {
    supportPage(publicationState: LIVE) {
      data {
        id
        attributes{
          faqheader{
            headertitle
            headerdescription
          }
          supportDetails
          faqdata{
            faqcategory
            faqs{
              question
              answer
            }
          }
          faqcard{
            cardlabel
            carddescription
          }
        }
      }
    }
  }
`;


export const ERROR_PAGE = gql`
  query($locale: I18NLocaleCode) {
    errorpage(locale: $locale) {
      data {
      id
      attributes {
       errorpageheader{
         headertitle
         headerdescription
       }
        errorpage_homelink{
          linklable
          url
        }              
      }
    }
    }
  }
`;

export const LEGAL_NOTICE = gql`
  query homePageData($locale: I18NLocaleCode) {
    homePage(locale: $locale) {
      data {
        id
        attributes {     
          legalnotice_content       
        }
      }
    }
  }
`;

export const METAL_INSIGHTS_BLOGS= gql`
  query blogdata($locale: I18NLocaleCode,$category:String) {
    blogs(locale: $locale, filters: { category:{title : { eq: $category }}}){
      data{
        id
        attributes{   
          blog_identifier      
          title
          subtitle
          description
          body
          createdAt
          image{
            data{
              attributes{
            url
          }
        }
      }
        }
      }
    }
  }
`;
// export const METAL_INSIGHTS_BLOG= gql`
//   query GetBlog($locale: I18NLocaleCode, $id: ID) {
//     blog(locale: $locale, id:$id){
//       data{
//         id  
//         attributes{
//           description
//           title
//           subtitle
//           body
//           createdAt
//           image{
//             data{
//               attributes{
//             url
//           }
//         }
//       }
//         }
//       }
//     }
//   }
// `;
export const METAL_INSIGHTS_BLOG= gql`
  query GetBlog($locale: I18NLocaleCode,$blog_identifier:String) {
    blogs(locale: $locale, filters: {blog_identifier:{ eq: $blog_identifier}}){
      data{
        id
        attributes{         
          title
          subtitle
          description
          body
          createdAt
          image{
            data{
              attributes{
            url
          }
        }
      }
        }
      }
    }
  }
`;


